"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var BlazerBW_1 = require("./BlazerBW");
var BlazerPantsBW_1 = require("./BlazerPantsBW");
var BlazerPantsWB_1 = require("./BlazerPantsWB");
var BlazerWB_1 = require("./BlazerWB");
var CrossedArmsBW_1 = require("./CrossedArmsBW");
var CrossedArmsWB_1 = require("./CrossedArmsWB");
var EasingBW_1 = require("./EasingBW");
var EasingWB_1 = require("./EasingWB");
var PointingFingerBW_1 = require("./PointingFingerBW");
var PointingFingerWB_1 = require("./PointingFingerWB");
var PolkaDots_1 = require("./PolkaDots");
var RestingBW_1 = require("./RestingBW");
var RestingWB_1 = require("./RestingWB");
var RoboDanceBW_1 = require("./RoboDanceBW");
var RoboDanceOutline_1 = require("./RoboDanceOutline");
var RoboDanceWB_1 = require("./RoboDanceWB");
var ShirtBW_1 = require("./ShirtBW");
var ShirtPantsBW_1 = require("./ShirtPantsBW");
var ShirtPantsWB_1 = require("./ShirtPantsWB");
var ShirtWB_1 = require("./ShirtWB");
var WalkingBW_1 = require("./WalkingBW");
var WalkingFilled_1 = require("./WalkingFilled");
var WalkingWB_1 = require("./WalkingWB");
var Doc_1 = require("./Doc");
var DocProtectiveClothe_1 = require("./DocProtectiveClothe");
var DocStethoscope_1 = require("./DocStethoscope");
exports.StandingPose = {
    BlazerBW: BlazerBW_1.BlazerBW,
    BlazerPantsBW: BlazerPantsBW_1.BlazerPantsBW,
    BlazerPantsWB: BlazerPantsWB_1.BlazerPantsWB,
    BlazerWB: BlazerWB_1.BlazerWB,
    CrossedArmsBW: CrossedArmsBW_1.CrossedArmsBW,
    CrossedArmsWB: CrossedArmsWB_1.CrossedArmsWB,
    EasingBW: EasingBW_1.EasingBW,
    EasingWB: EasingWB_1.EasingWB,
    PointingFingerBW: PointingFingerBW_1.PointingFingerBW,
    PointingFingerWB: PointingFingerWB_1.PointingFingerWB,
    PolkaDots: PolkaDots_1.PolkaDots,
    RestingBW: RestingBW_1.RestingBW,
    RestingWB: RestingWB_1.RestingWB,
    RoboDanceBW: RoboDanceBW_1.RoboDanceBW,
    RoboDanceOutline: RoboDanceOutline_1.RoboDanceOutline,
    RoboDanceWB: RoboDanceWB_1.RoboDanceWB,
    ShirtBW: ShirtBW_1.ShirtBW,
    ShirtPantsBW: ShirtPantsBW_1.ShirtPantsBW,
    ShirtPantsWB: ShirtPantsWB_1.ShirtPantsWB,
    ShirtWB: ShirtWB_1.ShirtWB,
    WalkingBW: WalkingBW_1.WalkingBW,
    WalkingFilled: WalkingFilled_1.WalkingFilled,
    WalkingWB: WalkingWB_1.WalkingWB,
    Doc: Doc_1.Doc,
    DocProtectiveClothe: DocProtectiveClothe_1.DocProtectiveClothe,
    DocStethoscope: DocStethoscope_1.DocStethoscope
};
//# sourceMappingURL=z_options.js.map